import { ContentWrapper } from "./content-wrapper";
export default ContentWrapper;